export default {
  computed: {
    computedNews() {
      return this.$marked(this.$state.ui.slangoNews?.content);
    }
  }
};